<template>
  <div id="CORequestAccept">
    <div id="container">
      <div class="labelTitle lable">ケア オーケストレーター 申請一覧</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>受付番号</th>
            <td><input type="text" id="receiptNumber" v-model="searchConditions.receiptNumber" maxlength="20"/></td>
            <th>種別</th>
            <td><select v-model="searchConditions.kind">
              <option v-for="kind in kindList" :value="kind.code" :key="kind.code">{{ kind.name }}</option>
              </select>
            </td>
            <th>状態</th>
            <td><select v-model="searchConditions.status">
              <option v-for="status in statusList" :value="status.code" :key="status.code">{{ status.name }}</option>
              </select>
            </td>
            <th>依頼元</th>
            <td><input type="text" id="client" v-model="searchConditions.client" maxlength="256"/></td>
          </tr>
          <tr>
            <th>医療機関名</th>
            <td><input type="text" id="hospital" v-model="searchConditions.hospital" maxlength="256"/></td>
            <th>医療機関<br>SAP番号</th>
            <td><input type="text" id="sapNumber" v-model="searchConditions.sapNumber" maxlength="20"/></td>
          </tr>
          <tr>
            <th>申込日</th>
            <td colspan="3"><input type="date" id="applicationDateStart" v-model="searchConditions.applicationDateStart"/> ～ <input type="date" id="applicationDateEnd" v-model="searchConditions.applicationDateEnd"/></td>
            <th>完了日</th>
            <td colspan="3"><input type="date" id="completionDateStart" v-model="searchConditions.completionDateStart"/> ～ <input type="date" id="completionDateEnd" v-model="searchConditions.completionDateEnd"/></td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch">検索</b-button>
        </div>
      </div>
      <!-- 検索結果 -->
      <div class="result-area" v-if="hasResult">
        <b-table
            id="CORequestAcceptTable"
            :data="data"
            :paginated="isPaginated"
            per-page="100"
            pagination-position="both"
            default-sort="user.first_name"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page">
            <template slot-scope="props">
                <b-table-column field="receiptNumber" label="受付番号" width="120" sortable centered>
                  <router-link :to="{name: 'CORequestAcceptDetail', params: {item: props.row, searchConditions}}"><a>{{props.row.receiptNumber}}</a></router-link>
                </b-table-column>
                <b-table-column field="kind" label="種別" width="120" sortable centered>
                  {{props.row.kind | coOrderTypeFilter()}}</b-table-column>
                <b-table-column field="client" label="依頼元" width="250" sortable>
                  {{props.row.client}}</b-table-column>
                <b-table-column field="hospital" label="医療機関名" width="130" sortable>
                  {{props.row.hospital}}</b-table-column>
                <b-table-column field="department" label="診療科名" width="120" sortable>
                  {{props.row.department}}</b-table-column>
                <b-table-column field="sapNumber" label="SAP番号" width="100" sortable>
                  {{props.row.sapNumber}}</b-table-column>
                <b-table-column field="applicationDate" label="申込日" width="120" sortable centered>
                  {{props.row.applicationDate}}</b-table-column>
                <b-table-column field="completionDate" label="完了日" width="120" sortable centered>
                  {{props.row.completionDate}}</b-table-column>
                <b-table-column field="applicationStatus" label="申込状況" width="100" sortable centered>
                  <span :class="getTagClass4CoInternalUserStatus(props.row.applicationStatus)" style="width:100px;">{{props.row.applicationStatus | coInternalStatusFilter()}}</span>
                </b-table-column>
            </template>
        </b-table>
      </div>
      <div class="searchButton-area">
        <router-link :to="{name:'COHome', params:{agent:true}}">
          <b-button class="is-primary">戻る</b-button>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import {coOrderType} from "@/components/mock/base/const.js";
import {coOrderTypeStr} from "@/components/mock/base/const.js";
import {coStatus} from "@/components/mock/base/const.js";
import {coStatusStr} from "@/components/mock/base/const.js";

export default {
  name: "CORequestAccept",
  methods: {
    doSearch: function() {
      var isSearchParam = false
      var keys = Object.keys(this.searchConditions)
      for(var i=0; i < keys.length; i++){
        if(this.searchConditions[keys[i]]){
          isSearchParam = true
          break;
        }
      }
      if(!isSearchParam){
        // 検索条件が１つも設定されていない場合
        this.showErrorMessage("検索条件が入力されていません。")
        return;
      }
      this.data = []
      this.checkedRows = []
      this.hasResult = false;
      var excuteApi = this.getCoApplicationListPOST;
      var successCallBack = this.getCoApplicationListPOSTSuccess;
      var errorCallBack = this.getCoApplicationListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getCoApplicationListPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      return client.apis.internalCo.getCoApplicationListPOST({
        body:obj
      });
    },
    getCoApplicationListPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      this.hasResult = true;
    },
    getCoApplicationListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    reception: function() {
      var excuteApi = this.setCoRegisteredPOST;
      var successCallBack = this.setCoRegisteredPOSTSuccess;
      var errorCallBack = this.setCoRegisteredPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setCoRegisteredPOST: function(client) {
      var obj = this.checkedRows
      return client.apis.internalCo.setCoRegisteredPOST({
        body:obj
      });
    },
    setCoRegisteredPOSTSuccess: function(result) {
      // 検索結果取得
      this.showSuccess(result)
      this.doSearch()
    },
    setCoRegisteredPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
  },
  data() {
    var takeOverSearchParams = this.$route.params["searchConditions"];
    // 種別リスト生成
    var kindList = [];
    for (let i=0; i < Object.values(coOrderType).length; i++) {
      kindList.push({
        code: Object.values(coOrderType)[i],
        name: Object.values(coOrderTypeStr)[i],
      });
    }
    kindList.unshift({});
    // 状態リスト生成
    var statusList = [];
    for (let i=0; i < Object.values(coStatus).length; i++) {
      statusList.push({
        code: Object.values(coStatus)[i],
        name: Object.values(coStatusStr)[i],
      });
    }
    statusList.unshift({});
    return {
        kindList,
        statusList,
        searchConditions:{
        receiptNumber:"",
        kind:"",
        status:"",
        client:"",
        hospital:"",
        sapNumber:"",
        applicationDateStart:"",
        applicationDateEnd:"",
        completionDateStart:"",
        completionDateEnd:""
      },
      data: [],
      isPaginated: true,
      hasResult:false,
      takeOverSearchParams
    };
  },
  async mounted() {
    if(this.takeOverSearchParams){
      this.searchConditions = this.takeOverSearchParams
      this.doSearch()
    }
  },
  filters: {},
  components: {},
};
</script>
<style lang="scss" scoped>
input {
  width: 200px;
}
a {
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/careorchestrator/CORequestAccept.vue